import { trackEvent, createElement } from '../utils';
export default function showGuideView() {
    // 避免蒙层引导被挂载多次
    const guideDom = document.getElementById('launch-app-guide-container');
    if (guideDom) {
        return;
    }
    const { rootViewEle, arrowPicEle, guidePicEle } = userGuideElements;
    const rootView = createElement(rootViewEle);
    const arrowPic = createElement(arrowPicEle);
    const guidePic = createElement(guidePicEle);
    rootView.appendChild(arrowPic);
    rootView.appendChild(guidePic);
    document.body.appendChild(rootView);
    // 埋点：引导浏览器打开页面曝光
    trackEvent('launch_app_user_guide_popup_expose');
    rootView.onclick = function () {
        rootView.remove();
    };
}
const userGuideElements = {
    rootViewEle: {
        label: 'div',
        className: 'launch-app-guide-view',
        props: {
            id: 'launch-app-guide-container'
        },
        style: {
            position: 'fixed',
            top: '0',
            left: '0',
            zIndex: 9999,
            width: '100vw',
            height: '100vh',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, .6)'
        },
    },
    arrowPicEle: {
        label: 'img',
        props: {
            src: 'https://ut-static.udache.com/webx/ut/fHqLDgx0WtEo4FiWRmnFK.png'
        },
        style: {
            width: '23.2vw',
            height: '28.93vw',
            position: 'absolute',
            top: '4.4vw',
            right: '6.13vw'
        },
    },
    guidePicEle: {
        label: 'img',
        props: {
            src: 'https://ut-static.udache.com/webx/ut/MfcLieAwgRx-n_D-JpPet.png'
        },
        style: {
            position: 'absolute',
            width: '81.6vw',
            height: '26.7vw',
            top: '35.2vw',
            left: 0,
            right: 0,
            margin: '0 auto'
        }
    }
};
